module.exports = __webpack_public_path__ + "static/media/copyCheckout.47d440e6.svg";